import type { CtaAlignment } from "@/utils/ctaAlignment";

export type BlogAlignDirection = "vertical" | "horizontal";

const HORIZONTAL_JUSTIFY: Record<CtaAlignment, string> = {
  left: "justify-start",
  center: "justify-center",
  right: "justify-end",
};

const VERTICAL_ITEMS: Record<CtaAlignment, string> = {
  left: "items-start",
  center: "items-center",
  right: "items-end",
};

/** Outer shell — slot children carry the flex layout. */
export function getBlogAlignClassName(): string {
  return "not-prose w-full min-w-0";
}

export function getBlogAlignSlotClassName(
  align: CtaAlignment,
  direction: BlogAlignDirection,
): string {
  const base = "flex min-w-0 w-full gap-2 [&>*]:max-w-full";

  if (direction === "horizontal") {
    return `${base} flex-row flex-wrap items-baseline ${HORIZONTAL_JUSTIFY[align]} [&>*]:w-auto`;
  }

  const vertical = `${base} flex-col ${VERTICAL_ITEMS[align]}`;

  if (align === "center") {
    return `${vertical} text-center`;
  }

  if (align === "right") {
    return `${vertical} text-right`;
  }

  return vertical;
}
